import { nameof } from "../../../../utils/nameof";
import { AssetPropertyRightKind, PropertyRightAnswers } from "../../../api/ClientFileApi";
import {
  DescribeMissingField,
  TENANCY_ENTRIES_FIELD,
  entriesMissing,
  itemField,
  requiredMessage,
} from "../../utils/missingFields.utils";
import { PropertyRightsFormValues } from "./OtherPropertyRightsView.types";
import { kindConfigOf } from "./OtherPropertyRightsView.utils";

const ANSWERS = nameof<PropertyRightsFormValues>("answers");
const PROPERTY_RIGHTS = nameof<PropertyRightsFormValues>("propertyRights");
const TENANT_OR_OWNER = nameof<PropertyRightAnswers>("tenantOrOwnerOfHomeAddress");

export const describeMissingPropertyRightField: DescribeMissingField<PropertyRightsFormValues> = (
  missing,
  values,
  t
) => {
  const { field } = missing;

  if (missing.itemId !== null) {
    return itemField(PROPERTY_RIGHTS, values.propertyRights, missing);
  }
  if (field === TENANCY_ENTRIES_FIELD) {
    return entriesMissing(`${ANSWERS}.${kindConfigOf(AssetPropertyRightKind.Tenancy).entryField}`, t);
  }
  if (field === TENANT_OR_OWNER) {
    return {
      path: `${ANSWERS}.${field}`,
      message: requiredMessage(
        t,
        "clients.client.debtSettlement.assetInventory.propertyRightsTab.tenancy.tenantOrOwnerLabel"
      ),
    };
  }
  return { path: `${ANSWERS}.${field}` };
};
